import {startCase} from 'lodash';

import {getActivePathFromPathname} from 'client/generic/SubjectMenuRenderer/subjectMenuData.utils';
import {courseLibraryPages} from 'client/generic/SubjectMenuRenderer/subjectMenuData';
import {publicUrl} from 'lib/head';

import {normalizePagePath} from './pageCopy';

const pages = new Map(courseLibraryPages.map((page) => [page.path, page]));

export function courseLibraryHeading(pathname: string): string {
  return pages.get(normalizePagePath(pathname))?.heading ?? 'Subject Library';
}

export function courseLibraryMetadata(pathname: string) {
  const path = normalizePagePath(pathname);
  const copy = pages.get(path);
  const [domain = 'All Subjects', group, subgroup] = getActivePathFromPathname(
    pathname,
    '/subjects'
  );
  const existingTitle = [subgroup, group, startCase(domain), 'Practice', 'Albert']
    .filter(Boolean)
    .join(' | ');
  if (!copy) {
    return {
      title: existingTitle
    };
  }

  const segments = path.split('/').filter(Boolean);
  const crumbs = [
    {name: 'Home', item: publicUrl('/')},
    ...segments.map((segment, index) => {
      const crumbPath = `/${segments.slice(0, index + 1).join('/')}`;
      return {
        name: pages.get(crumbPath)?.breadcrumb ?? startCase(segment),
        item: publicUrl(crumbPath)
      };
    })
  ];

  return {
    title: copy.title,
    metaDescription: copy.metaDescription,
    canonicalPath: path,
    robots: 'index, follow',
    structuredData: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          name: courseLibraryHeading(pathname),
          description: copy.metaDescription,
          url: publicUrl(path),
          isPartOf: {'@type': 'WebSite', name: 'Albert', url: 'https://www.albert.io'}
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: crumbs.map((crumb, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            ...crumb
          }))
        }
      ]
    }
  };
}
